<template lang="pug">
  .gvl-funding
    .notice-box Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind.

    p Genaue Informationen zur Antragstellung, zum Förderverfahren und zur Abrechnung der Förderung finden Sie in den FAQ und in den Fördergrundsätzen. Bitte lesen Sie die Informationen vor allem in den FAQ gründlich durch, bevor Sie Ihren Antrag stellen.
    p Bei weiteren Fragen wenden Sie sich an unsere Hotline unter:
    p.text-center.mt-3.mb-2: strong 0202-2515 57305
    p.text-center Montag bis Sonntag von 6:00 bis 22:00 Uhr

    p.mt-4 Nutzen Sie ausschließlich die o.g. Rufnummer. Die dortigen Ansprechpartner sind geschult, Ihnen weiterzuhelfen. Andere Mitarbeiter der GVL können Ihnen bezüglich des GVL-Stipendienprogramms nicht weiterhelfen. Anfragen per E-Mail können leider nicht berücksichtig werden.

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class Contact extends Vue {

}
</script>
